export default {
  type: 'menu',
  code: '17000000'
}
